var BxSliderJs = (function ($) {
    function changeBorderColor($currentImg, $remainingImg) {
        $remainingImg.css("border-color", "#ddd");
        $currentImg.css("border-color", "black");
    }

    function changeMainPreview($currentImg) {
        var $mainImgLink = $(".image-gallery-container a");
        var $mainImg = $mainImgLink.find("img.gallery-main-image");

        $mainImg.attr("src", $currentImg.data("medium-image"));
        $mainImgLink.attr("href", $currentImg.data("big-image"));

    }
    return {
        changeBorderColor: changeBorderColor,
        changeMainPreview: changeMainPreview
    }
}) (jQuery);


$(document).ready(function(){
    $(".image-gallery-container").css("border", "none");
    $('.gallery-image-container').bxSlider({
        mode: 'vertical',
        slideWidth: 95,
        minSlides: 2,
        slideMargin: 10,
        infiniteLoop: false,
        pager: false,
        touchEnabled: false,
        hideControlOnEnd: true
    });

    var $galleryImg = $(".gallery-image-container .slide img");
    $galleryImg.on('click', function() {
        BxSliderJs.changeBorderColor($(this), $galleryImg);
        BxSliderJs.changeMainPreview($(this));
    });

    $galleryImg.first().trigger("click");
    $galleryImg.css("opacity", 1);

});

